import { render } from "./MyDateComponent.vue?vue&type=template&id=6c802150"
import script from "./MyDateComponent.vue?vue&type=script&lang=js"
export * from "./MyDateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cc/www/doit2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__